import {Box, Modal, Stack} from "@mui/material";
import {ModalType} from "data/enums";
import {useViewController} from "data/services/locator/locator_hook.service";
import {isEqual} from "lodash";
import {observer} from "mobx-react";
import React from "react";
import {
	ModalBox,
	ModalContentCustom,
	ModalDescription,
} from "views/components/modals/modal_common.component";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {Bindings} from "data/constants/bindings";
import {ButtonPrimary, ModalCloseButton} from "views/components/buttons/buttons.component";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";

const ButtonRow = styled(Box)`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
	margin-bottom: 20px;

	@media (max-width: 600px) {
		//flex-direction: column;
	}

	button,
	a {
		@media (max-width: 600px) {
			width: 100%;
		}
	}
`;

export const ModalShare: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, modalContent, close, shareFB, shareTw} = controller;
	const isVisible = isEqual(visibleModal, ModalType.SHARE_MODAL);

	if (!isVisible) {
		return null;
	}

	return (
		<Modal open={isVisible}>
			<ModalBox>
				<ModalContentCustom>
					<Stack direction={"column"} alignItems={"center"}>
						<ModalCloseButton onClick={close}>
							<CloseIcon />
						</ModalCloseButton>
						<h1>{i18n.t("modal.share.title", "Share contest")}</h1>
						<ModalDescription>
							{i18n.t("modal.share.description", "Share description")}
						</ModalDescription>

						<ButtonRow>
							<ButtonPrimary
								fullWidth
								variant="contained"
								onClick={() => shareFB(Number(modalContent?.contestId) ?? 0)}>
								{i18n.t("league.invite.invite_via_fb", "Facebook")}
							</ButtonPrimary>

							<ButtonPrimary
								fullWidth
								variant="contained"
								onClick={() => shareTw(Number(modalContent?.contestId) ?? 0)}>
								{i18n.t("league.invite.invite_via_tw", "Twitter")}
							</ButtonPrimary>
						</ButtonRow>
					</Stack>
				</ModalContentCustom>
			</ModalBox>
		</Modal>
	);
});
